// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"244":"38b52262","779":"3cbe3251","996":"4538cf15"}[chunkId] + ".chunk.js";
};